module.exports = __webpack_public_path__ + "static/media/Omnifood.76740a4a.png";